import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box } from 'components/ui';
import mapHistoryTabPresentation from 'components/Content/BeautyInsider/BeautyInsiderHistory/mapHistoryTabPresentation';
import HistoryYearAtGlanceSection from 'components/Content/BeautyInsider/BeautyInsiderHistory/HistoryYearAtGlanceSection';
import Empty from 'constants/empty';

/**
 * Renders the BI History tab Year at a Glance section.
 *
 * @param {Object} props
 * @param {Object} props.profile Recognized/sign-in/BI state and user attributes for History state selection.
 * @param {string} props.region Region code used by annual activity mapping.
 * @param {Object} props.yearAtGlance Year at a Glance DTO with loading/error flags and current-year data.
 * @param {Object} props.actions Retry and shop-now callbacks for section interactions.
 * @returns {React.ReactElement} History tab Year at a Glance content.
 */
const HistoryTab = ({ profile = Empty.Object, region = 'US', yearAtGlance = Empty.Object, actions = Empty.Object }) => {
    const presentation = mapHistoryTabPresentation({
        profile,
        region,
        yearAtGlance,
        actions
    });

    return (
        <Box
            data-testid='history-tab'
            marginTop={[4, 5]}
        >
            <HistoryYearAtGlanceSection section={presentation.sections.yearAtGlance} />
        </Box>
    );
};

HistoryTab.propTypes = {
    profile: PropTypes.object,
    region: PropTypes.string,
    yearAtGlance: PropTypes.object,
    actions: PropTypes.object
};

export default wrapFunctionalComponent(HistoryTab, 'HistoryTab');
